'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndSocial } from '../../Entities/Ind/IndSocial';
export class IndSocialRepository extends CoreRepository {
  public createIndSocial(indId: number, payload: any[]) {
    return this.webAPI.createIndSocial(indId, payload).then((response) => {
      const indSocial = new IndSocial();
      indSocial.hydrate(response);

      return indSocial;
    });
  }

  public updateIndSocial(indId: number, indSocialId: number, payload: any[]) {
    return this.webAPI.updateIndSocial(indId, indSocialId, payload).then((response) => {
      return response;
    });
  }
}
